import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { FormikErrors, FormikProps } from 'formik'

import { observer } from 'mobx-react'

import MoneyField from 'modules/core/components/MoneyField'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { SectionHeader } from './SectionHeader'
import { CreateCardForm } from './useCardForm'

interface Props {
  form: FormikProps<CreateCardForm>
  currency: string
}

export type SettingsFields = {
  spendingAmount: string
  alias?: string
}

const getError = (field: keyof FormikErrors<SettingsFields>, form: Props['form']) => {
  return form.touched[field] ? form.errors[field] : ''
}

const SettingsForm = ({ form, currency }: Props) => {
  const showSpendingAmount = form.values.cardType === 'single_use'

  return (
    <Box gap="s32" width="full">
      <SectionHeader title={i18n.t('expenses_v2.forms.fields.header_card.title')} />
      {showSpendingAmount && (
        <Box gap="s6">
          <MoneyField
            mandatory
            placeholder="0"
            currency={currency}
            error={getError('spendingAmount', form)}
            onBlur={(ev) => {
              form.setFieldTouched('spendingAmount', true)
              form.handleBlur(ev)
            }}
            label={i18n.t('software_management.initial_setup.wizard.costs_form.budget')}
            value={form.values.spendingAmount}
            onChange={(value: string) => form.setFieldValue('spendingAmount', value)}
          />
        </Box>
      )}
      <Box gap="s6">
        <TextField
          label={i18n.t('expenses_v2.forms.fields.card_alias_non_optional.label')}
          value={form.values.alias}
          error={getError('alias', form)}
          onChange={(value: string) => form.setFieldValue('alias', value)}
          onBlur={(ev) => {
            form.setFieldTouched('alias', true)
            form.handleBlur(ev)
          }}
          placeholder={i18n.t('expenses_v2.forms.fields.card_alias_non_optional.placeholder')}
        />
        <Text color="grey700" size="200">
          {i18n.t('expenses_v2.forms.fields.card_alias_non_optional.example')}
        </Text>
      </Box>
    </Box>
  )
}

export default observer(SettingsForm)
